(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a-comp-locale-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-localization-form')) {
		class LTALocalizationForm extends HTMLElement {
			/* ----------------------------------------
			 * Setup
			 * ---------------------------------------- */
			constructor() {
				super()

				this.onClick = this.onClick.bind(this)
				this.onKeydown = this.onKeydown.bind(this)
				this.onSearchInput = this.onSearchInput.bind(this)
				this.onTriggerClick = this.onTriggerClick.bind(this)
				this.onDrawerOpen = this.onDrawerOpen.bind(this)
			}

			/* ----------------------------------------
			 * Lifecycle
			 * ---------------------------------------- */
			connectedCallback() {
				this.formEl = this.querySelector('form')
				this.countryInputEl = this.querySelector('input[name="country_code"]')
				this.languageInputEl = this.querySelector('input[name="language_code"]')
				this.tablistEl = this.querySelector('[role="tablist"]')
				this.drawerEl = this.closest('l-drawer')
				this.drawerId = this.drawerEl?.id || ''
				this.drawerName = this.drawerEl?.dataset?.drawerName || this.drawerId

				// In-drawer: tab clicks + country/language option picks
				this.addEventListener('click', this.onClick)
				this.addEventListener('input', this.onSearchInput)
				this.tablistEl?.addEventListener('keydown', this.onKeydown)

				// Outside triggers live in footer / announcement (not inside this CE)
				document.addEventListener('click', this.onTriggerClick)
				// Re-sync panel after l-drawer opens (focus-trap may land on first tab)
				document.addEventListener('l:drawer:open', this.onDrawerOpen)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick)
				this.removeEventListener('input', this.onSearchInput)
				this.tablistEl?.removeEventListener('keydown', this.onKeydown)
				document.removeEventListener('click', this.onTriggerClick)
				document.removeEventListener('l:drawer:open', this.onDrawerOpen)
			}

			/* ----------------------------------------
			 * Getters
			 * ---------------------------------------- */
			get tabEls() {
				return [...this.querySelectorAll('[role="tab"][data-locale-tab]')]
			}

			get panelEls() {
				return [...this.querySelectorAll('[data-locale-panel]')]
			}

			/* ----------------------------------------
			 * Outside triggers → open drawer on a panel
			 * ---------------------------------------- */

			/** True when the click target’s trigger belongs to this drawer instance */
			isOwnTrigger(triggerEl) {
				if (!triggerEl) return false
				if (!this.drawerId) return true
				return triggerEl.getAttribute('aria-controls') === this.drawerId
			}

			/**
			 * External buttons: [data-locale-trigger][data-locale-tab][aria-controls]
			 * Drawer open is handled by l-drawer (data-trigger-selector).
			 * We only set which panel (country | language) should show.
			 */
			onTriggerClick(event) {
				const triggerEl = event.target.closest('[data-locale-trigger]')
				if (!this.isOwnTrigger(triggerEl)) return

				const tabName = triggerEl.dataset.localeTab
				if (tabName) this.activateTab(tabName)
			}

			/**
			 * After drawer_open + focus trap: read which trigger opened us
			 * (drawer.triggerEl) and force that panel + move focus to its tab.
			 */
			onDrawerOpen(event) {
				if (this.drawerName && event.detail?.drawerName !== this.drawerName) return

				const tabName = this.drawerEl?.triggerEl?.dataset?.localeTab
				if (tabName) this.activateTab(tabName, { focusTab: true })
			}

			/* ----------------------------------------
			 * Tabs (ARIA tablist inside the drawer)
			 * ---------------------------------------- */
			activateTab(tabName, { focusTab = false } = {}) {
				if (!tabName || !this.panelEls.length) return

				this.tabEls.forEach((tabEl) => {
					const isActive = tabEl.dataset.localeTab === tabName
					tabEl.classList.toggle('is-active', isActive)
					tabEl.setAttribute('aria-selected', String(isActive))
					tabEl.setAttribute('tabindex', isActive ? '0' : '-1')
					if (focusTab && isActive) tabEl.focus()
				})

				this.panelEls.forEach((panelEl) => {
					const isActive = panelEl.dataset.localePanel === tabName
					panelEl.classList.toggle('l-hidden', !isActive)

					if (isActive) panelEl.removeAttribute('hidden')
					else panelEl.setAttribute('hidden', '')
				})
			}

			/** Arrow / Home / End on the tablist (WAI-ARIA Tabs pattern) */
			onKeydown(event) {
				const tabs = this.tabEls
				if (!tabs.length) return

				const currentIndex = tabs.indexOf(event.target.closest('[role="tab"]'))
				if (currentIndex < 0) return

				const last = tabs.length - 1
				let nextIndex = currentIndex

				switch (event.key) {
					case 'ArrowRight':
					case 'ArrowDown':
						nextIndex = (currentIndex + 1) % tabs.length
						break
					case 'ArrowLeft':
					case 'ArrowUp':
						nextIndex = (currentIndex - 1 + tabs.length) % tabs.length
						break
					case 'Home':
						nextIndex = 0
						break
					case 'End':
						nextIndex = last
						break
					default:
						return
				}

				event.preventDefault()
				this.activateTab(tabs[nextIndex].dataset.localeTab, { focusTab: true })
			}

			/* ----------------------------------------
			 * In-drawer clicks — tabs + localization options
			 * ---------------------------------------- */
			onClick(event) {
				const tabEl = event.target.closest('[role="tab"][data-locale-tab]')
				if (tabEl && this.contains(tabEl)) {
					event.preventDefault()
					this.activateTab(tabEl.dataset.localeTab)
					return
				}

				const optionEl = event.target.closest('[data-localization-option]')
				if (!optionEl || !this.formEl) return

				event.preventDefault()

				const inputEl = optionEl.dataset.localizationType === 'language' ? this.languageInputEl : this.countryInputEl
				if (!inputEl) return

				inputEl.value = optionEl.dataset.value
				this.formEl.submit()
			}

			/* ----------------------------------------
			 * Search filter (long country / language lists)
			 * ---------------------------------------- */
			onSearchInput(event) {
				if (!event.target.matches('[data-localization-search]')) return

				const panelEl = event.target.closest('[data-locale-panel]') || this
				const listEl = panelEl.querySelector('[data-localization-list]')
				const emptyTextEl = panelEl.querySelector('[data-empty-text]')
				if (!listEl) return

				const searchValue = event.target.value
				let hasResults = false

				listEl.querySelectorAll('[data-localization-option]').forEach((optionEl) => {
					const itemEl = optionEl.closest('[data-localization-item]')

					if (!searchValue) {
						itemEl?.classList.remove('l-hidden')
						hasResults = true
						return
					}

					const query = l_handleize(searchValue)
					const text = l_handleize(optionEl.dataset.text || optionEl.textContent || '')
					const value = l_handleize(optionEl.dataset.value || '')
					const isVisible = text.includes(query) || value.includes(query)

					itemEl?.classList.toggle('l-hidden', !isVisible)
					if (isVisible) hasResults = true
				})

				emptyTextEl?.classList.toggle('l-hidden', hasResults)
			}
		}

		customElements.define('l-localization-form', LTALocalizationForm)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["a-pdp-media-model"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-product-model')) {
		class LTAProductModel extends HTMLElement {
			constructor() {
				super()
				this._onPosterClick = this._onPosterClick.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this.posterEl = this.querySelector('[data-poster]')
				if (!this.posterEl || this.hasAttribute('data-loaded')) return

				this.posterEl.addEventListener('click', this._onPosterClick)
				this._cleanups.push(() => this.posterEl.removeEventListener('click', this._onPosterClick))
			}

			disconnectedCallback() {
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_onPosterClick() {
				if (this.hasAttribute('data-loaded')) return

				const templateEl = this.querySelector('template')
				if (!templateEl) return

				this.append(templateEl.content.cloneNode(true))
				this.toggleAttribute('data-loaded', true)

				if (window.Shopify?.loadFeatures) {
					window.Shopify.loadFeatures([
						{
							name: 'model-viewer-ui',
							version: '1.0',
							onLoad: this._setupModelViewerUI.bind(this),
						},
					])
				}

				this.querySelector('model-viewer')?.focus()
				this.dispatchEvent(new CustomEvent('l:product-model:loaded', { bubbles: true }))
			}

			_setupModelViewerUI(errors) {
				if (errors) return

				const viewer = this.querySelector('model-viewer')
				if (!viewer || !window.Shopify?.ModelViewerUI) return

				this.modelViewerUI = new window.Shopify.ModelViewerUI(viewer)
			}
		}

		customElements.define('l-product-model', LTAProductModel)
	}

	if (!window.ProductModel) {
		window.ProductModel = {
			loadShopifyXR() {
				if (!window.Shopify?.loadFeatures) return

				window.Shopify.loadFeatures([
					{
						name: 'shopify-xr',
						version: '1.0',
						onLoad: this.setupShopifyXR.bind(this),
					},
				])
			},

			setupShopifyXR(errors) {
				if (errors) return

				if (!window.ShopifyXR) {
					document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR())
					return
				}

				document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
					window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
					modelJSON.remove()
				})
				window.ShopifyXR.setupXRElements()
			},
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => window.ProductModel.loadShopifyXR())
		} else {
			window.ProductModel.loadShopifyXR()
		}
	}
  } catch(e) { console.error(e); }
})();

})();
